"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "CounterBadge", {
    enumerable: true,
    get: function() {
        return CounterBadge;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useCounterBadge = require("./useCounterBadge");
const _useCounterBadgeStylesstyles = require("./useCounterBadgeStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const _index = require("../Badge/index");
const CounterBadge = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useCounterBadge.useCounterBadge_unstable)(props, ref);
    (0, _useCounterBadgeStylesstyles.useCounterBadgeStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useCounterBadgeStyles_unstable')(state);
    return (0, _index.renderBadge_unstable)(state);
});
CounterBadge.displayName = 'CounterBadge';
